<div class="dashboard-table-container">
  <!-- Search and Filter Section -->
  <div class="table-header">
    <div class="header-spacer"></div>
    
    <div class="search-container">
      <mat-form-field appearance="outline" class="search-field" floatLabel="never">
        <mat-icon matPrefix class="search-icon">search</mat-icon>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
        <mat-icon matSuffix class="clear-icon" *ngIf="searchValue" (click)="clearSearch()">close</mat-icon>
      </mat-form-field>
    </div>
    
    <!-- Column Visibility Controls -->
    <div class="column-controls">
      <button mat-icon-button [matMenuTriggerFor]="columnMenu" class="gear-button">
        <mat-icon>settings</mat-icon>
      </button>
      <mat-menu #columnMenu="matMenu" class="column-menu" [hasBackdrop]="true" [backdropClass]="'menu-backdrop'">
        <div class="column-list" (click)="$event.stopPropagation()">
          <mat-checkbox 
            [checked]="areAllColumnsSelected()"
            [indeterminate]="someColumnsSelected()"
            (change)="toggleAllColumns(); $event.stopPropagation()"
            (click)="$event.stopPropagation()"
            class="column-checkbox all-checkbox">
            All
          </mat-checkbox>
          <mat-checkbox 
            *ngFor="let column of allColumns; trackBy: trackByColumn" 
            [checked]="getTempColumnState(column.key)"
            (change)="onColumnSelectionChange(column.key, $event); $event.stopPropagation()"
            (click)="$event.stopPropagation()"
            class="column-checkbox">
            {{ column.label }}
          </mat-checkbox>
        </div>
        <div class="menu-footer" (click)="$event.stopPropagation()">
          <button mat-raised-button color="primary" (click)="applyColumnChanges()" class="apply-button">
            Apply
          </button>
        </div>
      </mat-menu>
    </div>
  </div>

  <!-- Table Section -->
  <div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort class="dashboard-table">
      
      <!-- Date Created Column -->
      <ng-container matColumnDef="dateCreated" *ngIf="isColumnVisible('dateCreated')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</th>
        <td mat-cell *matCellDef="let element" [title]="element.dateCreated | date:'dd-MMM-yy HH:mm:ss'">{{ element.dateCreated | date:'dd-MMM-yy HH:mm:ss' }}</td>
      </ng-container>

      <!-- Country Column -->
      <ng-container matColumnDef="country" *ngIf="isColumnVisible('country')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
        <td mat-cell *matCellDef="let element" [title]="element.country">{{ element.country }}</td>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="type" *ngIf="isColumnVisible('type')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let element" [title]="element.type">{{ element.type }}</td>
      </ng-container>

      <!-- Local ID Column -->
      <ng-container matColumnDef="localId" *ngIf="isColumnVisible('localId')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Local ID</th>
        <td mat-cell *matCellDef="let element" [title]="element.localId">
          <span class="truncate-text">{{ element.localId }}</span>
        </td>
      </ng-container>

      <!-- Account ID Column -->
      <ng-container matColumnDef="accountId" *ngIf="isColumnVisible('accountId')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account ID</th>
        <td mat-cell *matCellDef="let element" [title]="element.accountId">
          <span class="truncate-text">{{ element.accountId }}</span>
        </td>
      </ng-container>

      <!-- Account Name Column -->
      <ng-container matColumnDef="accountName" *ngIf="isColumnVisible('accountName')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Name</th>
        <td mat-cell *matCellDef="let element" [title]="element.accountName">
          <span class="truncate-text">{{ element.accountName }}</span>
        </td>
      </ng-container>

      <!-- Account Status Column -->
      <ng-container matColumnDef="accountStatus" *ngIf="isColumnVisible('accountStatus')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Status</th>
        <td mat-cell *matCellDef="let element" [title]="element.accountStatus">
          <span class="status-badge" [ngClass]="getStatusClass(element.accountStatus)" style="display: block; width: min-content; font-weight: bold;">
            {{ element.accountStatus }}
          </span>
        </td>
      </ng-container>

      <!-- Delivery Column -->
      <ng-container matColumnDef="delivery" *ngIf="isColumnVisible('delivery')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Delivery</th>
        <td mat-cell *matCellDef="let element" [title]="element.delivery">
          <span class="delivery-badge" [ngClass]="getDeliveryClass(element.delivery)" style="font-weight: bold;">
            {{ element.delivery }}
          </span>
        </td>
      </ng-container>

      <!-- Feedback Column -->
      <ng-container matColumnDef="feedback" *ngIf="isColumnVisible('feedback')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Feedback</th>
        <td mat-cell *matCellDef="let element" [title]="element.feedback">
          <span class="feedback-badge" [ngClass]="getFeedbackClass(element.feedback)" style="font-weight: bold;">
            {{ element.feedback }}
          </span>
        </td>
      </ng-container>

      <!-- Hidden Columns (initially hidden) -->
      
      <!-- Global ID Column -->
      <ng-container matColumnDef="globalId" *ngIf="isColumnVisible('globalId')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Global ID</th>
        <td mat-cell *matCellDef="let element" [title]="element.globalId">
          <span class="truncate-text">{{ element.globalId }}</span>
        </td>
      </ng-container>

      <!-- Date Sent Column -->
      <ng-container matColumnDef="dateSent" *ngIf="isColumnVisible('dateSent')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Sent</th>
        <td mat-cell *matCellDef="let element" [title]="element.dateSent | date:'dd-MMM-yy HH:mm:ss'">{{ element.dateSent | date:'dd-MMM-yy HH:mm:ss' }}</td>
      </ng-container>

      <!-- Date Delivered Column -->
      <ng-container matColumnDef="dateDelivered" *ngIf="isColumnVisible('dateDelivered')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Delivered</th>
        <td mat-cell *matCellDef="let element" [title]="element.dateDelivered | date:'dd-MMM-yy HH:mm:ss'">{{ element.dateDelivered | date:'dd-MMM-yy HH:mm:ss' }}</td>
      </ng-container>

      <!-- Date Read Column -->
      <ng-container matColumnDef="dateRead" *ngIf="isColumnVisible('dateRead')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Read</th>
        <td mat-cell *matCellDef="let element" [title]="element.dateRead | date:'dd-MMM-yy HH:mm:ss'">{{ element.dateRead | date:'dd-MMM-yy HH:mm:ss' }}</td>
      </ng-container>

      <!-- Date Feedback Column -->
      <ng-container matColumnDef="dateFeedback" *ngIf="isColumnVisible('dateFeedback')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Feedback</th>
        <td mat-cell *matCellDef="let element" [title]="element.dateFeedback | date:'dd-MMM-yy HH:mm:ss'">{{ element.dateFeedback | date:'dd-MMM-yy HH:mm:ss' }}</td>
      </ng-container>

      <!-- Delivery Failures Column -->
      <ng-container matColumnDef="deliveryFailures" *ngIf="isColumnVisible('deliveryFailures')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Delivery Failures</th>
        <td mat-cell *matCellDef="let element" [title]="element.deliveryFailures === 'True' ? 'Yes' : ''">
          <div style="border-radius: 16px;width: 30px !important; text-align: center;" [ngClass]="{ failedColorDelivery: element.deliveryFailures === 'True' }" class="chip truncate-text" oneChip oneChipAppearance="outline">
            {{ element.deliveryFailures === 'True' ? 'Yes' : '' }}
          </div>
        </td>
      </ng-container>

      <!-- Days to Open Column -->
      <ng-container matColumnDef="daysToOpen" *ngIf="isColumnVisible('daysToOpen')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Days to Open</th>
        <td mat-cell *matCellDef="let element" [title]="element.daysToOpen">{{ element.daysToOpen }}</td>
      </ng-container>

      <!-- Days to Submit Column -->
      <ng-container matColumnDef="daysToSubmit" *ngIf="isColumnVisible('daysToSubmit')">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Days to Submit</th>
        <td mat-cell *matCellDef="let element" [title]="element.daysToSubmit">{{ element.daysToSubmit }}</td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
          class="table-row"></tr>
    </table>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Loading notifications...</p>
  </div>

  <!-- No Data State -->
  <div *ngIf="!isLoading && (dataSource.data.length === 0 || dataSource.filteredData.length === 0)" class="no-data-container">
    <p *ngIf="dataSource.data.length === 0">No data found</p>
    <p *ngIf="dataSource.data.length > 0 && dataSource.filteredData.length === 0">No search results found</p>
  </div>

  <!-- Pagination -->
  <mat-paginator 
    [pageSizeOptions]="[10, 25, 50, 100, 250, 500]" 
    [pageSize]="25"
    [showFirstLastButtons]="true"
    [length]="totalCount"
    (page)="onPageChange($event)"
    class="dashboard-paginator">
  </mat-paginator>
</div>
